import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { ExcelProjectImport_excel_project_import_library_homeComponent } from './ExcelProjectImport.excel_project_import_library_home.component';
import { ExcelProjectImport_excel_project_import_gridComponent } from './ExcelProjectImport.excel_project_import_grid.component';
import { ExcelProjectImport_owners_dd_singleComponent } from './ExcelProjectImport.owners_dd_single.component';
import { ExcelProjectImport_owners_dd_multiComponent } from './ExcelProjectImport.owners_dd_multi.component';

import { Utilities_ShellService } from './Utilities.shell.service';

@Injectable({ providedIn: 'root' })
export class ExcelProjectImport_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
  ) {
    super(dialog, toastr);
  }

  public ExcelProjectImport: ExcelProjectImport_ShellService = this;

  public openexcel_project_import_library_home(replaceCurrentView?: boolean) {
    this.$logger.log('ExcelProjectImport', 'excel_project_import_library_home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Home',
        referenceName: 'ExcelProjectImport_excel_project_import_library_home',
        component: ExcelProjectImport_excel_project_import_library_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openexcel_project_import_library_homeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('ExcelProjectImport', 'excel_project_import_library_home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ExcelProjectImport_excel_project_import_library_homeComponent,
      'Home',
      mode,
      dialogSize
    )
  }
  public openexcel_project_import_grid(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Project import',
        referenceName: 'ExcelProjectImport_excel_project_import_grid',
        component: ExcelProjectImport_excel_project_import_gridComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openexcel_project_import_gridDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      ExcelProjectImport_excel_project_import_gridComponent,
      'Project import',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'ExcelProjectImport_excel_project_import_library_home') {
      this.$logger.log('ExcelProjectImport', 'excel_project_import_library_home');
      const title = 'Home';
      const component = ExcelProjectImport_excel_project_import_library_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelProjectImport_excel_project_import_grid') {
      const title = 'Project import';
      const component = ExcelProjectImport_excel_project_import_gridComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelProjectImport_owners_dd_single') {
      this.$logger.log('ExcelProjectImport', 'owners_dd_single');
      const title = 'Owners dropdown';
      const component = ExcelProjectImport_owners_dd_singleComponent;
      const inParams:{ statusId?: number } = { statusId: null };
      if (!isNil(params.get('statusId'))) {
        const paramValueString = params.get('statusId');
        inParams.statusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }
    if (referenceName === 'ExcelProjectImport_owners_dd_multi') {
      this.$logger.log('ExcelProjectImport', 'owners_dd_multi');
      const title = 'Owners dropdown';
      const component = ExcelProjectImport_owners_dd_multiComponent;
      const inParams:{ statusId?: number } = { statusId: null };
      if (!isNil(params.get('statusId'))) {
        const paramValueString = params.get('statusId');
        inParams.statusId = this.convertToNumber(paramValueString);
      }

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
